import { Action } from 'helpers/action-helpers';
import { Guid } from 'types/guid';
import { User } from 'types/user';

export const LOAD_USER_PROFILE = 'LoadUserProfileAction';
export const GET_USER_PROFILE = 'GetUserProfileAction';
export const SET_USER_PROFILE = 'SetUserProfileAction';
export const UPDATE_USER_PROFILE = 'UpdateUserProfileAction';
export const PROCESSING_USER = 'ProcessingUserAction';
export const SET_USER_PROFILE_ERROR_MESSAGE = 'SetUserProfileErrorMessageAction';

export class LoadUserProfileAction extends Action {
  constructor() { 
    super(LOAD_USER_PROFILE);
  }
}
export class GetUserProfileAction extends Action {
  constructor(public userId: Guid) { 
    super(GET_USER_PROFILE);
  }
}

export class SetUserProfileAction extends Action {
  constructor(public user: User) { 
    super(SET_USER_PROFILE);
  }
}

export class UpdateUserProfileAction extends Action {
  constructor(public userId: Guid, public user: User) { 
    super(UPDATE_USER_PROFILE);
  }
}

export class ProcessingUserAction extends Action {
  constructor() { 
    super(PROCESSING_USER);
  }
}

export class SetUserProfileErrorMessageAction extends Action {
  constructor(public errorMessage: string) { 
    super(SET_USER_PROFILE_ERROR_MESSAGE);
  }
}


// WEBPACK FOOTER //
// ./src/pages/user-profile/actions.ts